var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgUsersOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67588 6.11905C6.92761 6.11905 7.95967 5.09464 7.95967 3.80952C7.95967 2.52441 6.92761 1.5 5.67588 1.5C4.42415 1.5 3.39209 2.52441 3.39209 3.80952C3.39209 5.09464 4.42415 6.11905 5.67588 6.11905ZM5.67588 7.61905C7.76561 7.61905 9.45967 5.91347 9.45967 3.80952C9.45967 1.70558 7.76561 0 5.67588 0C3.58615 0 1.89209 1.70558 1.89209 3.80952C1.89209 5.91347 3.58615 7.61905 5.67588 7.61905ZM11.3514 18.5001V14.2858C11.3514 11.1299 8.81028 8.57153 5.67568 8.57153C2.54109 8.57153 0 11.1299 0 14.2858V18.5001V20.0001H1.5H9.85137H11.3514V18.5001ZM9.85137 18.5001V14.2858C9.85137 11.9487 7.97228 10.0715 5.67568 10.0715C3.37909 10.0715 1.5 11.9487 1.5 14.2858V18.5001H9.85137ZM10.6605 6.68347C10.3909 6.68347 10.1373 6.61108 9.91634 6.48373C9.66358 6.88437 9.35411 7.24188 9 7.54353C9.46999 7.89117 10.0426 8.09524 10.6605 8.09524C12.2583 8.09524 13.5535 6.73077 13.5535 5.04762C13.5535 3.36447 12.2583 2 10.6605 2C10.5379 2 10.417 2.00804 10.2984 2.02365C10.4753 2.4567 10.5923 2.92332 10.6383 3.41193L10.6605 3.41176C11.5181 3.41176 12.2134 4.14416 12.2134 5.04762C12.2134 5.95108 11.5181 6.68347 10.6605 6.68347ZM15 16.5882V13.4286C15 10.9038 13.0572 8.85714 10.6605 8.85714C10.541 8.85714 10.4225 8.86224 10.3054 8.87223C10.8029 9.29921 11.2332 9.82274 11.5749 10.4184C12.7842 10.8258 13.6599 12.0194 13.6599 13.4286V16.5882H12.4472V18H13.6599H15V16.5882Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersOutlined);
export default __webpack_public_path__ + "static/media/usersOutlined.f6e69388243b3a7ff801117a5c095f82.svg";
export { ForwardRef as ReactComponent };